import React, { useState , useEffect } from 'react';
import { useSelector } from 'react-redux';
import './IvMeasurementStatusInfo.css';
import '../../App.css';
import IV_REMS from '../Iv_ErrorCode/IV_REMS';
import IvError from '../Iv_ErrorCode/IvError';
import OcipError from '../Iv_ErrorCode/OcipError';
import GrowattError from '../Iv_ErrorCode/GrowattError';
import FoxError from '../Iv_ErrorCode/FoxError';
import Goodwe120KError from '../Iv_ErrorCode/Goodwe120KError';
import Goodwe60KError from '../Iv_ErrorCode/Goodwe60KError';
import SpaceoneError from '../Iv_ErrorCode/SpaceoneError';
import DongeiError from '../Iv_ErrorCode/DongeiError';
import useIsRemsIv from '../../hooks/useIsRemsIv';
import useIsMobile from '../../hooks/useIsMobile';
import useIsOcipIv from '../../hooks/useIsOcipIv';
import useIsGrowatt from '../../hooks/useIsGrowatt';
import useIsFoxIv from '../../hooks/useIsFoxIv';
import useIsDik from '../../hooks/useIsDik';
import DikError from '../Iv_ErrorCode/DikError';
import Das_techError from '../Iv_ErrorCode/Das_techError';
import DasTechStringError from '../Iv_ErrorCode/DasTechStringError';
import useIsDas_tech from '../../hooks/useIsDas_tech';
import useIsDas_inv_string from '../../hooks/useIsDas_inv_string';
import useIsHex_3 from '../../hooks/useIsHex_3';
import Hex_3Error from '../Iv_ErrorCode/Hex_3Error';
import useIsG2powerIv from '../../hooks/useIsG2powerIv';
import G2PowerError from '../Iv_ErrorCode/G2Power_Error';
import useIsTeldaIv from '../../hooks/useIsTeldaIv';
import useIsUnitestInv from '../../hooks/useIsUnitestInv';
import Unitest_Error from '../Iv_ErrorCode/Unitest_Error';
import Basic_Error from '../Iv_ErrorCode/Basic_Error';
import useIsHyIv from '../../hooks/useIsHyIv';
import useIsSpaceone from '../../hooks/useIsSpaceone';
import useIsDongeiInv from '../../hooks/useIsDongeiInv';
import useIsWillingsInv from '../../hooks/useIsWillingsInv';
import useIsGoodweGw120kIv from '../../hooks/useIsGoodweGw120kIv';
import useIsGoodwe60kIv from '../../hooks/useIsGoodwe60kIv';
import useIsHuawei50kIv from '../../hooks/useIsHuawei50kIv';
import WillingsFault from '../Iv_ErrorCode/Willings_Error_M';
import Huawei50kError from '../Iv_ErrorCode/Huawei50kError';

const IvMeasurementStatusInfo = ({ SelInverter }) => {
  const isMobile = useIsMobile();
  const Iv_list = useSelector((state) => state.Iv_list || {});
  const [index, Setindex] = useState(null);

  // 인버터 선택 시 index 설정
    useEffect(() => {
      if (Iv_list.seq && Array.isArray(Iv_list.seq)) {
        const foundIndex = Iv_list.seq.findIndex(seq => seq === SelInverter);
        if (foundIndex !== -1) {
          Setindex(foundIndex);
        }
      }
    }, [Iv_list, SelInverter]);

    const isRems = useIsRemsIv(SelInverter);
    const isOcip = useIsOcipIv(SelInverter);
    const isGrowatt = useIsGrowatt(SelInverter);
    const isFox = useIsFoxIv(SelInverter);
    const isDik = useIsDik(SelInverter);
    const isDas_tech = useIsDas_tech(SelInverter);
    const isDas_inv_string = useIsDas_inv_string(SelInverter);
    const ishex_3 = useIsHex_3(SelInverter);
    const isG2power = useIsG2powerIv(SelInverter);
    const isTelda = useIsTeldaIv(SelInverter);
    const isUnitest = useIsUnitestInv(SelInverter);
    const isHy = useIsHyIv(SelInverter);
    const isSpaceone = useIsSpaceone(SelInverter);
    const isDongei = useIsDongeiInv(SelInverter);
    const isWillings = useIsWillingsInv(SelInverter);
    const isGoodweGw120k = useIsGoodweGw120kIv(SelInverter);
    const isGoodwe60k = useIsGoodwe60kIv(SelInverter);
    const isHuawei50k = useIsHuawei50kIv(SelInverter);
    return (
    <div>
      <div style={{ margin: '10px', maxWidth: '800px' }}>
        <div className='inverterGenInfo-TopBox'>
          <div>
            <div style={{ disaply: 'flex', color: '#6B7476', fontSize: isMobile? '17px':'20px', fontWeight: '600', paddingLeft: '20px' }}>◎ 상태정보</div>
          </div>
          <div style={{ flexGrow: '1' }}></div>
          {!isRems && (
            <div style={{ marginRight: '10px', fontSize: isMobile? '14px':'16px' }}>
              정상🟢 이상🔴
            </div>
          )}
          <div style={{ color: '#6B7476', fontSize: isMobile? '17px':'20px', fontWeight: '600', paddingRight: '20px' }}>⦁ ⦁ ⦁</div>
        </div>
        
        <div className='inverterGenInfo-BottomBox'>
          <div className="container">
            {isRems ? (
              <IV_REMS SelInverter={SelInverter} />
            ) : isOcip ? (
              <OcipError SelInverter={SelInverter} />
            ) : isGrowatt ? (
              <GrowattError SelInverter={SelInverter} />
            ) : isDik ? (
              <DikError SelInverter={SelInverter} />
            ) : isDas_inv_string ? (
              <DasTechStringError SelInverter={SelInverter} />
            ) : isDas_tech ? (
              <Das_techError SelInverter={SelInverter} />
            ) : ishex_3 ? (
              <Hex_3Error SelInverter={SelInverter} />
            ) : isFox ? (
              <FoxError SelInverter={SelInverter} />
            ) : isGoodweGw120k ? (
              <Goodwe120KError SelInverter={SelInverter} />
            ) : isGoodwe60k ? (
              <Goodwe60KError SelInverter={SelInverter} />
            ) : isHuawei50k ? (
              <Huawei50kError SelInverter={SelInverter} />
            ) : isG2power ? (
              <G2PowerError SelInverter={SelInverter} />
            ) : isUnitest ? (
              <Unitest_Error SelInverter={SelInverter} />
            ) : isSpaceone ? (
              <SpaceoneError SelInverter={SelInverter} />
            ) : isDongei ? (
              <DongeiError SelInverter={SelInverter} />
            ) : isHy ? (
              <IvError SelInverter={SelInverter} />
            ) : isWillings ? (
              <WillingsFault SelInverter={SelInverter} />
            ) : (
              <Basic_Error SelInverter={SelInverter} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default IvMeasurementStatusInfo;
